import { Box, IconButton } from "@material-ui/core";
import i18next from "../../../assets/i18n/i18n";
import React, { useState } from "react";
import "../buttons.scss";
import ConfirmationUnlinkDialog from "../../../pages/onboarding/components/confirmation-unlink-modal/confirmation-unlink-modal";

type Props = {
    onDecouple: () => void;
};

const ButtonUnlinkAccount = ({ onDecouple }: Props): React.ReactElement => {
    const [openModal, setOpenModal] = useState(false);

    const showModal = () => setOpenModal(true);
    const closeModal = () => setOpenModal(false);
    const handleDecouple = () => {
        closeModal();
        onDecouple();
    };

    return (
        <Box>
            <IconButton id="BtnUnlinkAccount" className="btn primary-btn" onClick={showModal}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9 0.531235C4.18359 0.531235 0.28125 4.43358 0.28125 9.24998C0.28125 14.0664 4.18359 17.9687 9 17.9687C13.8164 17.9687 17.7188 14.0664 17.7188 9.24998C17.7188 4.43358 13.8164 0.531235 9 0.531235ZM9 16.8437C4.81641 16.8437 1.40625 13.4687 1.40625 9.24998C1.40625 5.10155 4.78125 1.65623 9 1.65623C13.1484 1.65623 16.5938 5.06639 16.5938 9.24998C16.5938 13.4336 13.1836 16.8437 9 16.8437ZM12.3047 6.8242C12.4805 6.64842 12.4805 6.40233 12.3047 6.22655L12.0234 5.9453C11.8477 5.76952 11.6016 5.76952 11.4258 5.9453L9 8.37108L6.53906 5.9453C6.39844 5.76952 6.11719 5.76952 5.94141 5.9453L5.66016 6.22655C5.48438 6.40233 5.48438 6.64842 5.66016 6.8242L8.08594 9.24998L5.66016 11.7109C5.48438 11.8515 5.48438 12.1328 5.66016 12.3086L5.94141 12.5898C6.11719 12.7656 6.39844 12.7656 6.53906 12.5898L9 10.164L11.4258 12.5898C11.6016 12.7656 11.8477 12.7656 12.0234 12.5898L12.3047 12.3086C12.4805 12.1328 12.4805 11.8515 12.3047 11.7109L9.87891 9.24998L12.3047 6.8242Z"
                        fill="#005645"
                    />
                </svg>
                <p className="btn-label unlink-account-btn-label">{i18next.t("Buttons.UnlinkAccount")}</p>
            </IconButton>
            <ConfirmationUnlinkDialog open={openModal} onClose={closeModal} onDecouple={handleDecouple} />
        </Box>
    );
};

export default ButtonUnlinkAccount;
